import { apiV2Instance } from '../../lib/api-v2.client';

export class AppService {
  getAppDetails() {
    return apiV2Instance.get(`/api/public`).then(response => {
      return response.data;
    });
  }
}
